import AirList from "./AirList"

export default  AirList;



// WEBPACK FOOTER //
// ./src/common/components/AirList/index.js